<template>
  <div v-if="show">
    <!-- <tableSearch
      @search="search = $event"
      :placeholder="
        $t('SEARCH_FOR', { type: $t('FULL_NAME') + ' ' + $t('DRIVER_TITLE') })
      "
    /> -->
    <titleHolder :title="$t('HISTORY_REPORT_STOPS')" />
    <customDialog
      v-if="showMap"
      :title="dialogTitle"
      childClass="info_msg"
      :show="showMap"
      customWidth="60%"
      :showClose="true"
      @show="showMap = $event"
      :showCancel="false"
      @confirmButn="showMap = false"
    >
      <div class="col-span-full mb-4" id="mapid" ref="mapElement"></div>
    </customDialog>
    <el-table
      :empty-text="$t('NO_DATA')"
      row-class-name="notSticky"
      :data="
        updatingTable.filter(
          (data) =>
            !search ||
            (data.driver &&
              (data.driver.first_name.includes(search) ||
                data.driver.last_name.includes(search)))
        )
      "
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('DRIVER_TITLE')" width="150">
        <template slot-scope="scope">
          <div :data-title="$t('FULL_NAME')">
            <span v-if="scope.row.driver">
              {{
                scope.row.driver.first_name + " " + scope.row.driver.last_name
              }}
            </span>
            <span v-else class="text-gray-400"> {{ $t("NO_DRIVER") }} </span>
          </div>
        </template>
      </el-table-column> -->

      <!-- <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('IMEI')" width="190">
        <template slot-scope="scope">
          <div :data-title="$t('IMEI')">
            <span>
              {{ scope.row.device.imei }}
            </span>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('VEHICLE_TITLE')" width="150">
        <template slot-scope="scope">
          <LicensePlate :vehicle="scope.row.company_vehicle.vehicle"
            :license_plate="scope.row.company_vehicle.license_plate" :chars="alphaList">
          </LicensePlate>
        </template>
      </el-table-column> -->

      <!-- <el-table-column prop="sim_number" :align="$i18n.locale == 'fa' ? 'right' : 'left'" :label="$t('SIM_NUMBER')"
        width="160">
        <template slot-scope="scope">
          <div :data-title="$t('SIM_NUMBER')" class="text-sm">
            {{ "0" + scope.row.device.sim_number }}
          </div>
        </template>
      </el-table-column> -->

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TIME')"
        width="280"
      >
        <template slot-scope="scope">
          <div
            :data-title="$t('TIME')"
            class="flex flex-col justify-end lg:justify-center"
          >
            <p class="flex items-center">
              <span class="text-gray-500 text-xs ml-2">
                {{ $t('START_TIME') }}:
              </span>
              <span
                >{{
                  new Date(scope.row.start_datetime).toLocaleTimeString('fa-IR')
                }}
                |
                {{
                  new Date(scope.row.start_datetime).toLocaleDateString('fa-IR')
                }}</span
              >
            </p>
            <p class="flex items-center">
              <span class="text-gray-500 text-xs ml-2">
                {{ $t('END_TIME') }}:
              </span>
              <span
                >{{
                  new Date(scope.row.stop_datetime).toLocaleTimeString('fa-IR')
                }}
                |
                {{
                  new Date(scope.row.stop_datetime).toLocaleDateString('fa-IR')
                }}</span
              >
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="`${$t('DURATION')} (${$t('HOUR')})`"
        width="140"
      >
        <template slot-scope="scope">
          <div :data-title="`${$t('DURATION')} (${$t('HOUR')})`">
            {{ calculateHour(scope.row.duration) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('COORDINATES')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('COORDINATES')">
            <span
              @click="showDialog(scope.row.point[0], scope.row.point[1])"
              class="text-carpo cursor-pointer"
            >
              {{ $t('SHOW_ON_MAP') }}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <Pagination parameter="and" :pagination="{
      count: updatingTable.count,
      current: +$route.query.p,
      request: `trips/stops/?company_vehicle=${updatingTable.results.length > 0
        ? updatingTable.results[0].company_vehicle.id
        : ''
        }`,
    }" @tableData="updatingTable = $event" @loading="updatingLoading = $event" /> -->
  </div>
</template>

<script>
// import tableSearch from '@/components/elements/tableSearch'
import { calculateHour } from '@/mixins/calculateHour'
// import Pagination from "@/components/elements/pagination";
import config from '@/configs/configs.js'
import customDialog from '@/components/elements/dialog'
import titleHolder from '@/components/elements/title.vue'
// import LicensePlate from "@/components/cars/LicensePlate";
// import { licenseChars } from "@/api/global";

export default {
  props: ['tableData', 'loading'],
  mixins: [calculateHour],
  components: {
    // tableSearch,
    // Pagination,
    customDialog,
    titleHolder,
    // LicensePlate
  },
  data() {
    return {
      search: '',
      show: false,
      updatingTable: this.tableData,
      updatingLoading: this.loading,
      showMap: false,
      map: null,
      defaultCoordinate: [35.71343059526645, 51.407055307645365],
      marker: null,
      dialogTitle: '',
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
    }
  },
  watch: {
    tableData(val) {
      if (val && val.length > 0) {
        this.show = true
        this.updatingTable = val
      }
    },
  },
  methods: {
    showDialog(lat, lng) {
      this.showMap = true
      this.defaultCoordinate = [lat, lng]
      let this_ = this
      setTimeout(function () {
        this_.loadMap()
      }, 500)
      this.marker = null
      setTimeout(() => {
        this_.addMarker(this_.map, [lat, lng], false)
        this_.map.setView(new L.LatLng(lat, lng), 15)
      }, 700)
    },
    loadMap() {
      var map = L.map(this.$refs['mapElement'], { tap: false }).setView(
        this.defaultCoordinate,
        10
      )
      L.tileLayer(config.tile, {
        attribution: '@ Carpo',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: config.leaflet,
      }).addTo(map)
      this.map = map
    },
    addMarker(map, corrdinate = this.defaultCoordinate, draggable = false) {
      var greenIcon = L.icon({
        iconUrl: '../../../../pin.png',
        iconSize: [38, 38],
      })

      var this_ = this
      let marker = new L.marker(corrdinate, {
        draggable: draggable,
        icon: greenIcon,
      })
      this_.marker = marker

      map.addLayer(marker)
    },
  },
  // mounted() {
  //   licenseChars.api().then((res) => {
  //     this.alphaList = res;
  //   });
  // }
}
</script>
